export default {
  slug: 'ws-slider',
  MODAL_WIDTH: 338,
  DELAY: {
    min: 1,
    max: 25,
  },
};
